import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback } from 'react';
import { useOuterClick, useOverlay, useControlledFlagState, useRootRef, eventBus } from '@deliveryhero/armor-system';
import { useCommonDatePickerPopper } from './useCommonDatePickerPopper';
import { DATE_RANGE_PICKER_CLOSE_PANEL } from '../DateRangePicker/constants';
export var useCommonDatePickerPanel = function useCommonDatePickerPanel(_ref, _ref2) {
  var ref = _ref.ref;
  var open = _ref2.open,
    defaultOpen = _ref2.defaultOpen,
    onOpenChange = _ref2.onOpenChange,
    zIndex = _ref2.zIndex,
    enablePortal = _ref2.enablePortal;
  var _useCommonDatePickerP = useCommonDatePickerPopper(),
    dropdownRef = _useCommonDatePickerP.dropdownRef,
    triggerRef = _useCommonDatePickerP.triggerRef,
    dropdownProps = _useCommonDatePickerP.dropdownProps,
    arrowProps = _useCommonDatePickerP.arrowProps;
  // main panel open/close
  var _useControlledFlagSta = useControlledFlagState(defaultOpen, open, onOpenChange),
    _useControlledFlagSta2 = _slicedToArray(_useControlledFlagSta, 5),
    dropdownOpen = _useControlledFlagSta2[0],
    closeDropdown = _useControlledFlagSta2[3],
    toggleDropdown = _useControlledFlagSta2[4];
  var _useOverlay = useOverlay(dropdownOpen, {
      zIndex: zIndex
    }),
    realZIndex = _useOverlay.zIndex,
    panelId = _useOverlay.id;
  var onReallyDropdownClose = useCallback(function () {
    eventBus.dispatch(DATE_RANGE_PICKER_CLOSE_PANEL, {
      id: panelId
    });
    closeDropdown();
  }, [closeDropdown, panelId]);
  var rootRef = useRootRef(ref);
  // main panel close on outer click
  useOuterClick([rootRef, dropdownRef], onReallyDropdownClose, dropdownOpen);
  return {
    rootRef: rootRef,
    inputRef: triggerRef,
    dropdownOpen: !!dropdownOpen,
    toggleDropdown: toggleDropdown,
    closeDropdown: onReallyDropdownClose,
    portalProps: {
      enablePortal: enablePortal
    },
    dropdownProps: _objectSpread(_objectSpread({}, dropdownProps), {}, {
      zIndex: realZIndex
    }),
    arrowProps: arrowProps,
    panelId: panelId
  };
};